<!-- Start of Selection -->
<app-sidebar></app-sidebar>
<div class = "header-mobile">
    <img src = "/assets/logo_2x.png" alt="Conectio Logo" class="logo">
</div> 

<!-- Start of Selection -->
<div *ngIf="isPasswordCorrect; else passwordCheck">
    <div class="interview-viewer-container">
        <div class="interview-viewer-header">
            <h2>Xpeer: Customer success</h2>
        </div>

        <div class="interview-viewer-video">
            <h3>Entrevista a Vanessa Machuca Tiberi</h3>
            <video width="600" controls>
                <source src="assets/video-interviews/vanessa-xpeer.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
</div>

<ng-template #passwordCheck>
    <div class="password-check">
        <h3>Por favor, introduce el identificador secreto del proceso de selección:</h3>
        <mat-form-field appearance="fill">
            <input matInput type="password" [(ngModel)]="password" (keyup.enter)="checkPassword()" placeholder="Enter password" required>
        </mat-form-field>
        <button mat-button (click)="checkPassword()" style="margin-top: 15px;">Acceder</button>
        <p *ngIf="passwordIncorrect" style="color: red;">Incorrect password. Please try again.</p>
    </div>
</ng-template>

<app-footer></app-footer>
<!-- End of Selection -->
